import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '../lib/cn.ts';

export const badgeVariants = cva(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-xs px-1.5 py-px text-caption font-bold',
  {
    variants: {
      tone: {
        /** Метка на поверхности: специализация, категория. */
        neutral: 'border border-border bg-surface-2 text-text',
        /** Итог и этап — чёрная плашка: «Утверждена», «Выиграна», «Опубликован», «Действует». */
        strong: 'bg-strong text-on-strong',
        /** Акцент: бренд и выделение — «Рекомендуем», «это вы». Не «хорошо»: хорошее идёт без цвета или `strong`. */
        accent: 'bg-accent text-on-accent',
        /** Внимание: маржа ниже нормы. */
        warn: 'bg-warn-soft text-text',
        danger: 'bg-danger-soft text-danger',
        muted: 'text-muted',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps extends ComponentProps<'span'>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
